<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useLocale } from '@/composables/useLocale'
import { setLocale } from '@/plugins/i18n'

import mdiMenuDown from '~icons/mdi/menu-down'

import 'flag-icons/css/flag-icons.min.css'

// Language menu shared by the login view and the navigation.

const { t } = useI18n()
const { allLocales, currentFlag } = useLocale()

const currentFlagClass = computed(() => `fi fi-${currentFlag.value}`)

async function selectLanguage(language: string) {
  // setLocale is async (lazy locale load) — OneTrust must follow the COMMITTED
  // i18n locale, or rapid switches can leave the two out of sync.
  await setLocale(language)
  window.OneTrust?.changeLanguage(language)
}
</script>

<template>
  <div>
    <v-btn
      :append-icon="mdiMenuDown"
      :aria-label="t('common.language')"
      rounded
    >
      <span
        :class="currentFlagClass"
        class="flag"
      />
    </v-btn>

    <v-menu activator="parent">
      <v-list>
        <v-list-item
          v-for="{ code, flag } in allLocales"
          :key="code"
          @click="selectLanguage(code)"
        >
          <template #prepend>
            <span
              :class="`fi fi-${flag}`"
              class="mr-4"
            />
          </template>

          {{ t(`locale.${code}`) }}
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<style scoped>
.flag {
  border-radius: 5px;
}
</style>
